import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import { FormControl } from '@mui/material'

import { ListSports } from '@/enums'
import AutocompleteCustom from '@/views/components/autocomplete-custom/index.component'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

export const SportsFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const [fieldSports] = useField('sports')

  const listSportsObject = []
  const listSportsOptions = []

  Object.values(ListSports).forEach((value) => {
    if (Number.isNaN(Number(value))) {
      const item = {
        name: t(`restrictionsItems.${value}`),
        id: value,
      }
      listSportsOptions.push(value)
      listSportsObject.push(item)
    }
  })

  return (
    <FormControl fullWidth margin="none">
      <AutocompleteCustom
        id="sports"
        name="sports"
        placeholder={
          fieldSports.value === '' || fieldSports.value.length === 0
            ? t('labels.selectSports')
            : ''
        }
        options={listSportsOptions}
        getOptionLabel={(option: any) =>
          listSportsObject.find((sportOption) => sportOption.id === option)
            ?.name || ''
        }
        limitTags={2}
        multiple
        value={fieldSports.value}
        onChange={(_, newValue: any | null) => {
          handleChangeSearch('sports', newValue)
        }}
        label={t('labels.sports')}
        sx={{ '& .MuiFormControl-root': { marginTop: '8px' } }}
      />
    </FormControl>
  )
}
